import _typeof from "@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import RichText from '~/components/ui/RichText';
export default defineComponent({
  name: 'CategoriesDescription',
  components: {
    RichText: RichText
  },
  props: {
    description: {
      type: Object | String,
      required: true
    }
  },
  setup: function setup(props) {
    var descriptionType = computed(function () {
      return _typeof(props.description);
    });
    var isDescriptionObject = computed(function () {
      return descriptionType.value === 'object';
    });
    var categoriesDescriptionKey = computed(function () {
      return JSON.stringify(props.description);
    });
    var categoriesDescription = computed(function () {
      return props.description;
    });
    return {
      isDescriptionObject: isDescriptionObject,
      categoriesDescriptionKey: categoriesDescriptionKey,
      categoriesDescription: categoriesDescription
    };
  }
});